import { IStores, storeContext } from "../stores/StoreProvider";
import { useStoreData } from "./useStoreDataHook";

export const useRootData = (
  dataSelector: (store: IStores) => any
) => useStoreData(storeContext, contextData => contextData!, dataSelector);